import { ListItem, ListItemButton, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import React, { useState, MouseEvent, ReactElement } from "react";
import { ReactComponent as LogoutIcon } from '../../assets/Icons/adornments/Logout.svg';
import { DropdownOption } from "./Dropdown";
import { useLogoutAuthenticationLogoutPost } from "../../api/generated/fastAPI";
import { useNavigate } from "react-router-dom";
import ChangePasswordModal from "../Popups/ChangePasswordModal";
import { useAccess } from "../../access/useAccess";
import { demo_access } from "../../access/predefinedConditions";


export default function ProfileDropdown({
    isNavOpen,
    name,
    email,
    initials,
    setPopupMessage,
}: {
    isNavOpen: boolean,
    name: string,
    email: string,
    initials: string,
    setPopupMessage:  (popupMessage: string, isSuccessMessage: boolean) => void,
}) {
    const logoutMutation = useLogoutAuthenticationLogoutPost();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const navigate = useNavigate();
    const { canAccess } = useAccess();
    
    const open = Boolean(anchorEl);

    const handleClick = (event: any) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    let options: DropdownOption[] = []
    if (canAccess({or: demo_access})) options.push({
        label: 'Change Password',
        btnComp: (
            <ChangePasswordModal 
                setPopupMessage={setPopupMessage}
            />
        )
    })

    const logout = async (e: MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();

        try {
            await logoutMutation.mutateAsync();
            navigate('/');
        } catch (err:any) {
            console.log(err);
            handleClose();
        }
    }

    return (
        <div>
            <ListItem disablePadding sx={{display: 'block'}}>
                <ListItemButton
                    onClick={handleClick}
                    sx={[
                        {
                        minHeight: 48,
                        px: 2.5,
                        },
                        isNavOpen
                        ? {
                            justifyContent: 'initial',
                            }
                        : {
                            justifyContent: 'center',
                            },
                    ]}
                >
                    <ListItemIcon
                        sx={[
                            {
                            minWidth: 0,
                            justifyContent: 'center',
                            },
                            isNavOpen
                            ? {
                                mr: 3,
                                }
                            : {
                                mr: 'auto',
                                },
                        ]}
                    >
                        <div className='w-[24px] bg-[#ABCED1] font-semibold text-default text-[12px] rounded-full aspect-square flex justify-center items-center'>{initials}</div>
                    </ListItemIcon>
                    <ListItemText
                        primary={name}
                        primaryTypographyProps={{
                            fontFamily: 'Montserrat',
                            fontWeight: 500,
                            color: '#9292AA',
                        }}
                        sx={[
                            isNavOpen
                            ? {
                                opacity: 1,
                                }
                            : {
                                opacity: 0,
                                },
                        ]}
                    />
                </ListItemButton>
            </ListItem>

            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                sx={{
                    marginTop: '8px',
                    '& .MuiMenu-list': {
                        padding: 0,
                    }
                }}
                slotProps={{
                    paper: {
                        sx: {
                            borderRadius: '8px'
                        }
                    }
                }}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "center",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                MenuListProps={{
                'aria-labelledby': 'basic-button',
                }}
            >
                {options.map((option, i) => (
                    <MenuItem key={i} onKeyDown={(e) => e.stopPropagation()} sx={{
                        fontFamily: 'Montserrat',
                        fontWeight: 'medium',
                        color: `#35424A`,
                        backgroundColor: `#ffffff`,
                        // padding: '12px 20px',
                        padding: 0,
                    }} onClick={(e:any) => {option.action && option.action(e); e.stopPropagation()}}>
                        {option.btnComp ? (
                            <>
                            { option.btnComp = React.Children.map(option.btnComp, el => {
                                return React.cloneElement(el as ReactElement, { handleCloseMenu: handleClose })
                            })}
                            </>
                        ) : (
                        <button onClick={() => { handleClose(); }} className={`w-full px-5 py-3 text-left font-medium flex justify-between items-center gap-3 w-full h-full`}>
                            <div className='flex justify-start items-center gap-3'>
                                {option.startingAdornment && <div className='w-[18px] h-[18px]'>{option.startingAdornment}</div>}
                                <p className='text-nowrap'>{option.label}</p>
                            </div>
                        </button>
                        )}
                    </MenuItem>
    
                ))}
                <MenuItem sx={{
                    fontFamily: 'Montserrat',
                    fontWeight: 'medium',
                    color: `#35424A`,
                    backgroundColor: `#ffffff`,
                    padding: '12px 20px',
                }} onClick={(e:any) => {e.stopPropagation(); logout(e)}}>
                    <button className={`text-left font-medium flex justify-between items-center gap-3 w-full h-full`}>
                        <div className='flex justify-start items-center gap-3'>
                            {<div className="w-[16px]"><LogoutIcon/></div>}
                            <p className='text-nowrap'>Logout</p>
                        </div>
                    </button>
                </MenuItem>
            </Menu>
        </div>
    )
}